export default (value) => {
  if (value > 0) {
    return 'up';
  } if (value < 0) {
    return 'down';
  }
  return 'zero';
};
